//CustomMapMarker 완성본

import { CustomOverlayMap } from 'react-kakao-maps-sdk';
import { Location } from '../../domain/models/locations/Location';
import { ReactComponent as MapMarkerIcon } from '../../icons/map.maker.svg';

interface CustomMapMarkerProps {
  location: Location;
  onClickMarker: (location: Location) => void;
  isSelected?: boolean;
  forceDarkMode?: boolean;
  markerColor: string;
  shadowColor: string;
  iconSrc?: string;
}

export const CustomMapMarker = ({
  location,
  onClickMarker,
  isSelected = false,
  forceDarkMode = false,
  markerColor = '#382599', // 기본값 네이비
  shadowColor = '#382599',
  iconSrc
}: CustomMapMarkerProps) => {
  return (
    <CustomOverlayMap
      key={location.locationId}
      position={{
        lat: Number(location.latitude),
        lng: Number(location.longitude)
      }}
      zIndex={isSelected ? 100 : 1} // ★ 여기 추가!
    >
      <button
        type="button"
        aria-label={`marker-${location.locationId}`}
        className={`relative flex items-center justify-center w-[${isSelected ? 50 : 30}px]`}
        style={{
          filter: forceDarkMode ? 'invert(1) hue-rotate(180deg)' : undefined
        }}
        onClick={() => {
          onClickMarker(location);
        }}
      >
        {/* <div
        className={`relative flex items-center justify-center
          w-[${isSelected ? 50 : 30}px]
        `}
        onClick={() => {
          onClickMarker(location);
        }}
      > */}
        <MapMarkerIcon
          width={30}
          className="relative flex items-center justify-center"
          style={{ fill: markerColor }}
        />
        <div
          className={'absolute rounded-full'}
          style={{
            background: markerColor, // ★ 여기만 변경
            top: isSelected ? '-15px' : '0',
            width: isSelected ? '50px' : '30px',
            height: isSelected ? '50px' : '30px'
          }}
        />
        <div
          className={'absolute rounded-full bg-white'}
          style={{
            top: isSelected ? '-11px' : '3px',
            width: isSelected ? '42px' : '24px',
            height: isSelected ? '42px' : '24px',
            boxShadow: isSelected
              ? shadowColor.startsWith('0px')
                ? shadowColor // box-shadow 전체 스타일이 들어오면 그대로
                : `0px 0px 18px 0px ${shadowColor}` // 컬러만 들어오면 기존처럼
              : ''
            // filter: forceDarkMode ? 'invert(1) hue-rotate(180deg)' : ''
          }}
        />
        <img
          alt={location.siteTypeIconName()}
          src={
            iconSrc ??
            (location.isLiked
              ? '/assets/icons/graphic-3d/3D.like.png'
              : `/assets/icons/graphic-3d/${location.siteTypeIconName()}.png`)
          }
          className={'absolute flex flex-col items-center aspect-square'}
          style={{
            top: isSelected ? '-3px' : '6px',
            width: isSelected ? '26px' : '18px',
            height: isSelected ? '26px' : '18px'
            // filter: forceDarkMode ? 'invert(1) hue-rotate(180deg)' : ''
          }}
        />
      </button>
    </CustomOverlayMap>
  );
};


